import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import List from './list';

class App extends Component {
  render() {
    return (
      <div>
        <List />
        {/* <h4>Never put off till tomorrow... what’ll wait till the day after <img src="https://www.reactiongifs.us/wp-content/uploads/2018/01/giphy.gif" height="70px" /></h4> */}

      </div>
    );
  }
}

export default App;
